import React, { Component } from "react";
import { connect } from "react-redux";
import I18n from "lib/i18n/i18n";
import SideBar from "./sideBar";
import NoMatch from "../../components/noMatch";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import WorthyApi from "lib/api/worthyApi";
import { isMobile } from "helpers/ApplicationHelper";
import LogosFooter from "./logosFooter";
import ListingCharts from "./listingCharts";
import UserActions from "lib/userActions";
import { InfoAlert } from "@worthy-npm/clarity";
import { bindActionCreators } from "redux";
import { getItem } from "../../actions/item";

class ListingTrends extends Component {
    constructor(props) {
        super(props);

        this.state = {
            trends: "",
            estimations: "",
            isTop: false,
            showProperties: false,
            scrollPosition: 0,
        };
        this.version = I18n.getString("itemPage::trends::versions::v2");

        this.handleScroll = this.handleScroll.bind(this);
        this.sellButtonClick = this.sellButtonClick.bind(this);

        WorthyApi.getListingTrendsAndLog(this.props.params.itemId)
            .then((res) => {
                this.setState({
                    trends: res.data,
                });
            })
            .catch((error) => {
                this.setState({ trends: error });
            });
        this.props.getItem(this.props.params.itemId);
    }

    componentDidMount() {
        UserActions.trendsPage(
            "Trends page presented",
            this.props.params.itemId,
            this.version
        );
        if (isMobile) {
            window.addEventListener("scroll", this.handleScroll);
        }
    }

    handleScroll() {
        let scrollPosition = window.pageYOffset;
        let isTop = scrollPosition > 140;
        if (isTop !== this.state.isTop) {
            this.setState({ isTop });
        }
    }

    sellButtonClick() {
        UserActions.trendsPage(
            "Continue button clicked",
            this.props.params.itemId,
            this.version
        );
        window.location.pathname = `/item/${this.props.params.itemId}`;
    }

    render() {
        const { trends } = this.state;

        if (!trends) {
            return <noscript></noscript>;
        }

        let error = trends instanceof WorthyApiErrors;

        if (error && trends.hasError(404)) {
            return <NoMatch />;
        }

        let itemDescription =
            I18n.getString("itemPage::trends::your") +
            " " +
            (trends.desc || "");
        let isRing = trends.item_type_name === "ring" && trends.estimation;
        // let missing_trends_values = !error && Object.values(trends.trends).filter((x) => {return !x.length}).length // maybe to check Object.values(trends).flat() < 12*3

        if ((error && trends.hasError(500)) || !isRing || !trends.main_stone) {
            return <noscript></noscript>;
        }

        return (
            <div id="trends">
                <div className="wrapper">
                    <InfoAlert
                        text={I18n.getString(
                            "itemPage::trends::listingTrends::mainAlert"
                        )}
                        canClose={false}
                    />
                    <div id="title-section">
                        <div className="title">
                            {I18n.getString(
                                "itemPage::trends::listingTrends::title"
                            )}
                        </div>
                        <div className="sub-title">
                            {I18n.getString(
                                "itemPage::trends::listingTrends::subTitle"
                            )}
                        </div>
                    </div>
                    <div className="container">
                        <SideBar
                            trends={trends}
                            itemDescription={itemDescription}
                            onClick={this.sellButtonClick}
                        />
                        <ListingCharts
                            trends={trends}
                            item={this.props.item}
                            itemId={this.props.params.itemId}
                            listing={true}
                        />
                    </div>
                    <div className="footer">
                        <LogosFooter />
                    </div>
                </div>
                {isMobile() ? (
                    <div
                        className={
                            this.state.isTop
                                ? "mobile-footer sticky"
                                : "mobile-footer"
                        }
                    >
                        <div className="item-props-desc">{itemDescription}</div>
                        <button
                            id="second"
                            className="btn btn-orange sell-now"
                            onClick={this.sellButtonClick}
                        >
                            {I18n.getString("itemPage::trends::buttonSellNow")}
                        </button>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getItem }, dispatch);
};

const mapStateToProps = ({ Session, Item }) => {
    return {
        Session,
        item: Item,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ListingTrends);
